import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Clipboard14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M6 6.5C6 7.05228 5.55228 7.5 5 7.5C4.44772 7.5 4 7.05228 4 6.5C4 5.94772 4.44772 5.5 5 5.5C5.55228 5.5 6 5.94772 6 6.5Z'
      fill='currentColor'
    />
    <path
      d='M5 10.5C5.55228 10.5 6 10.0523 6 9.5C6 8.94771 5.55228 8.5 5 8.5C4.44772 8.5 4 8.94771 4 9.5C4 10.0523 4.44772 10.5 5 10.5Z'
      fill='currentColor'
    />
    <path d='M7 8.75V10.25H10V8.75H7Z' fill='currentColor' />
    <path d='M7 7.25V5.75H10V7.25H7Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.725 1.25H11.5C12.1904 1.25 12.75 1.80964 12.75 2.5V12.5C12.75 13.1904 12.1904 13.75 11.5 13.75H2.5C1.80964 13.75 1.25 13.1904 1.25 12.5V2.5C1.25 1.80964 1.80964 1.25 2.5 1.25H4.275C4.39082 0.67944 4.89526 0.25 5.5 0.25H8.5C9.10474 0.25 9.60918 0.67944 9.725 1.25ZM4.275 2.75H2.75V12.25H11.25V2.75H9.725C9.60918 3.32056 9.10474 3.75 8.5 3.75H5.5C4.89526 3.75 4.39082 3.32056 4.275 2.75ZM5.75 2.25V1.75H8.25V2.25H5.75Z'
      fill='currentColor'
    />
  </Svg>
);

Clipboard14.displayName = 'Clipboard14';
export default Clipboard14;
